import { render, staticRenderFns } from "./MultiselectTravelers.vue?vue&type=template&id=663b58a8&scoped=true&"
import script from "./MultiselectTravelers.vue?vue&type=script&lang=js&"
export * from "./MultiselectTravelers.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectTravelers.vue?vue&type=style&index=0&id=663b58a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b58a8",
  null
  
)

export default component.exports